import React from "react";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="tako-footer">
      <div className="footer-container">
        {/* BRAND */}
        <div className="footer-section brand">
          <h2>TAKO</h2>
          <p>
            An Ethiopian-based company creating high-quality wearable products
            for everyday use.
          </p>
          <div className="social-icons">
            {/* TikTok */}
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="TikTok"
              className="tiktok-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 256"
                fill="currentColor"
              >
                <path d="M198.91 86.15c-9.86 0-19.16-1.92-27.77-5.55v57.3a64.02 64.02 0 0 1-64-64V24h-36v64c0 44.18 35.82 80 80 80 14.85 0 28.63-4.36 40.22-11.9v45.32a123.6 123.6 0 0 1-40.22 6.67c-66.27 0-120-53.73-120-120V0h36v77.76a64.02 64.02 0 0 0 64 64c8.57 0 16.85-1.33 24.59-3.78v-52.83z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/tako_0304?igsh=MWNkM3dzb3pxNGpsag%3D%3D&utm_source=qr"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="instagram-icon"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>

        {/* CONTACT */}
        <div className="footer-section contact">
          <h3>Contact</h3>
          <p>
            <Phone size={16} />
            +251 994442355
          </p>

          <p>
            <MapPin size={16} /> Addis Ababa, Ethiopia
          </p>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} TAKO. All rights reserved.</p>
        <a
          href="https://www.goh.takoeth.com"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <p>© powered by Gohtech.</p>
        </a>
      </div>
    </footer>
  );
}
